import {
  FiMessageSquare,
  FiMail,
  FiCpu,
  FiLayers,
  FiRefreshCw,
  FiInbox,
  FiFileText,
  FiMonitor,
  FiLock,
} from "react-icons/fi";

// Support / legal contact shown on the Piggy pages. Swap for a dedicated
// address (e.g. piggy@yourdomain) if you don't want a personal inbox here.
export const PIGGY_EMAIL = "divinsmathew@gmail.com";
export const PIGGY_UPDATED = "20 September 2026";

export const STEPS = [
  {
    n: "01",
    title: "An alert arrives",
    copy: "Your bank already texts or emails you for every payment. Piggy listens for those alerts, and only those.",
  },
  {
    n: "02",
    title: "AI reads it",
    copy: "Amount, payee, time, and a sensible category are extracted in seconds. OTPs, statements, and failed payments are ignored.",
  },
  {
    n: "03",
    title: "One clean row",
    copy: "The payment lands in your ledger once, even when SMS and email both mention it. Refunds link back to the original.",
  },
];

export const FEATURES = [
  {
    icon: FiMessageSquare,
    title: "SMS alerts",
    copy: "Recognises Indian bank, UPI, and card headers out of the box. Add your own with one tap.",
  },
  {
    icon: FiMail,
    title: "Gmail alerts",
    copy: "Optional read-only Gmail access catches the alerts that arrive as email. Nothing is sent or changed.",
  },
  {
    icon: FiCpu,
    title: "Categories that learn",
    copy: "Fix a category once and Piggy remembers the payee and amount range for next time.",
  },
  {
    icon: FiLayers,
    title: "One payment, one row",
    copy: "Matching bank references collapse duplicates. Similar-looking payments are never merged by guesswork.",
  },
  {
    icon: FiRefreshCw,
    title: "Refunds, linked",
    copy: "A credited refund finds its original debit. Both stay visible, neither counts toward totals.",
  },
  {
    icon: FiInbox,
    title: "Review, not guesses",
    copy: "Anything ambiguous waits in Review. You decide to merge, keep, or discard.",
  },
  {
    icon: FiFileText,
    title: "Statement gaps",
    copy: "Import a bank or card CSV to fill in months where an alert never arrived.",
  },
  {
    icon: FiMonitor,
    title: "Web dashboard",
    copy: "Summary, activity, and analytics in the browser. Same Google sign-in, same ledger.",
  },
  {
    icon: FiLock,
    title: "Locked to you",
    copy: "Unlock with your fingerprint or device PIN. Sign in with Google, no passwords to remember.",
  },
];

export const READS = [
  "Transaction alerts from banks, cards, UPI apps, and merchants you allow",
  "The amount, payee, time, and reference inside those alerts",
  "Your Google account email, to know whose ledger is whose",
];

export const NEVER_READS = [
  "OTPs, verification codes, or password-reset messages",
  "Personal conversations or any SMS from a sender you have not allowed",
  "Full card or account numbers, which are never stored",
  "Email content outside matching transaction alerts. Gmail access is read-only",
];
